import React from 'react';
import { Button } from 'lmc-ui-library-rebrand';
import { FooterWrapper } from './Navigation.styled';

type Props = {
  onContinue?: () => void;
  onBack?: () => void;
  continueDisabled?: boolean;
};

const Navigation: React.FC<Props> = ({ onBack, onContinue, continueDisabled }) => {
  return (
    <FooterWrapper>
      {onBack && (
        <Button
          type="button"
          mode="ghost"
          borderVariant="rectangle"
          small={false}
          onClick={onBack}
          style={{ fontWeight: 'bold' }}>
          Back
        </Button>
      )}
      {onContinue && (
        <Button
          mode="primary"
          type="submit"
          borderVariant="rectangle"
          small={false}
          onClick={onContinue}
          disabled={continueDisabled}
          style={{ fontWeight: 'bold' }}>
          Continue
        </Button>
      )}
    </FooterWrapper>
  );
};

export default Navigation;
